import {IHttpPromise, IHttpService} from "angular";
import {CampaignToggle} from "../model/CampaignToggle";
import {getAbsoluteUrl} from "../../utils/urlUtill";

export class CampaignService {

    static instance = [
        '$http',
        CampaignService
    ];

    constructor(private $http: IHttpService) {
    }

    fetchCustomerCampaignToggles = (customerId: number):IHttpPromise<CampaignToggle[]> => {
        return this.$http({
            method: 'GET',
            url : getAbsoluteUrl(`api/customer/${customerId}/campaign_toggles`)
        })
    };

    fetchLoggedInUserCampaignToggles = ():IHttpPromise<CampaignToggle[]> => {
        return this.$http({
            method: 'GET',
            url : getAbsoluteUrl(`api/user/campaign_toggles`)
        })
    };

    updateCampaignConfiguration(configuration: CampaignToggle): IHttpPromise<any> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/campaigns'),
            data: configuration
        })
    }

    updateCampaignConfigurationToggle(customerId: number, configuration: CampaignToggle): IHttpPromise<any> {
        return this.$http({
            method: 'PUT',
            url: getAbsoluteUrl('api/campaigns'),
            data: {
                customerId: customerId,
                configuration: configuration
            }
        })
    }
}